import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/illustrations/progress-hd.png')"}
}
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, " Forgot Password ? "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-4" }, " Enter your email to reset your password. ")
], -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-gray-900 fs-6" }, "Email", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "d-flex flex-wrap justify-content-center pb-lg-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Field, {
            class: "form-control form-control-solid",
            type: "email",
            placeholder: "",
            name: "email",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            autocomplete: "off"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            ref: "submitButton",
            id: "kt_password_reset_submit",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmitForgotPassword && _ctx.onSubmitForgotPassword(...args))),
            class: "btn btn-lg btn-primary fw-bolder me-4"
          }, _hoisted_12, 512),
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn btn-lg btn-light-primary fw-bolder"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_14
  ]))
}